import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Top from "../top";
import Copyright from "../copyright";
import React, {useState} from "react";
import {Reveal} from "react-genie";
import {Link, makeStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import logo from "../../assets/gadogado_logo.png";
import gado from "../../assets/gado_chan.png";
import Grid from "@material-ui/core/Grid";
import Lightbox from "react-image-lightbox";
import LazyLoad from "react-lazyload";
import HistoryIcon from "@material-ui/icons/History";

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: "rgba(164,143,124, .9)",
        padding: theme.spacing(8, 0, 6),
    },
    imageBox: {
        width: "100%",
        display: "inline-block",
        position: "relative"
    },
    menuPickUpImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        [theme.breakpoints.up('md')]: {
            height: "550px"
        },
    },
    backNumber: {
        color: "#000",
    },
}));
export default function Dinner(props) {
    const {spMatches} = props;
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [oldMenuOpen, setOldMenuOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const [oldPhotoIndex, setOldPhotoIndex] = useState(0);
    const handleClickImage = (props) => {
        setPhotoIndex(props);
        setOpen(true);
    };
    const handleClickOldMenuOpen = (props) => {
        setOldPhotoIndex(props);
        setOldMenuOpen(true);
    };
    const images = [
        '/images/menu/dinner/1.png',
        '/images/menu/dinner/2.png',
        '/images/menu/dinner/3.png',
        '/images/menu/dinner/4.png',
        '/images/menu/dinner/5.png',
        '/images/menu/dinner/6.png',
        '/images/menu/dinner/7.png',
        '/images/menu/dinner/8.png',
        '/images/menu/dinner/9.png',
    ];
    const oldImages = [
        '/images/menu/dinner/before2022/1.jpg',
        '/images/menu/dinner/before2022/2.jpg',
        '/images/menu/dinner/before2022/3.jpg',
        '/images/menu/dinner/before2022/4.jpg',
        '/images/menu/dinner/before2022/5.jpg',
    ];
    return (
        <div className={classes.root}>
            <Reveal>
                {open && (
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => setOpen(false)}
                        onMovePrevRequest={() =>
                            setPhotoIndex((photoIndex + images.length - 1) % images.length)
                        }
                        onMoveNextRequest={() =>
                            setPhotoIndex((photoIndex + 1) % images.length)
                        }
                    />
                )}
                {oldMenuOpen && (
                    <Lightbox
                        mainSrc={oldImages[oldPhotoIndex]}
                        nextSrc={oldImages[(oldPhotoIndex + 1) % oldImages.length]}
                        prevSrc={oldImages[(oldPhotoIndex + oldImages.length - 1) % oldImages.length]}
                        onCloseRequest={() => setOldMenuOpen(false)}
                        onMovePrevRequest={() =>
                            setOldPhotoIndex((oldPhotoIndex + oldImages.length - 1) % oldImages.length)
                        }
                        onMoveNextRequest={() =>
                            setOldPhotoIndex((oldPhotoIndex + 1) % oldImages.length)
                        }
                    />
                )}
                <Box fontSize={spMatches ? "h2.fontSize": "h2.fontSize"}>
                    <Typography variant="h3" component="h2" className="text-black text-bold en">
                        GRAND
                    </Typography>
                    <Typography variant={spMatches ? "subtitle1" : "h5"} component="h2" className="text-black text-bold en" >
                        グランドメニュー
                    </Typography>
                </Box>
                <Box mt={1} p={spMatches ? 3 : 10}>
                    <Box display="flex">
                        <Grid container spacing={2} >
                            <Grid item xs={12} md={12}>
                                <div className={classes.imageBox}>
                                    <LazyLoad>
                                        <img src="/images/menu/dinner/1.png"
                                             alt="ディナー1" className={classes.menuPickUpImage}
                                             onClick={() => {
                                                 handleClickImage(0);
                                             }}
                                        />
                                    </LazyLoad>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Reveal>
            {spMatches && (
                <Reveal delay={200} className="balloon5">
                    <div className="faceicon">
                        <img src={gado} className={spMatches ? "gadochan-sp" : "gadochan"}
                             alt="ガドガドのキャラクター" />
                    </div>
                    <div className="chatting">
                        <div className="says">
                            <p>新メニューになりました。</p>
                        </div>
                    </div>
                    <div className="chatting">
                        <div className="says">
                            <Link
                                // className={classes.backNumber}
                                onClick={()=> {handleClickOldMenuOpen(0)}}>
                                <p>過去のMENUも見れるよ〜🙆</p>
                            </Link>
                        </div>
                    </div>
                </Reveal>
            )}
        </div>
    )
}
